import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SiteSettings {
  // Feature toggles
  foodOrderingEnabled: boolean;
  shopEnabled: boolean;
  ticketsEnabled: boolean;
  mapEnabled: boolean;

  // Actions
  setFoodOrderingEnabled: (enabled: boolean) => void;
  setShopEnabled: (enabled: boolean) => void;
  setTicketsEnabled: (enabled: boolean) => void;
  setMapEnabled: (enabled: boolean) => void;
}

export const useSettingsStore = create<SiteSettings>()(
  persist(
    (set) => ({
      // Default settings - food OFF, others ON
      foodOrderingEnabled: false,
      shopEnabled: true,
      ticketsEnabled: true,
      mapEnabled: true,

      setFoodOrderingEnabled: (enabled) => set({ foodOrderingEnabled: enabled }),
      setShopEnabled: (enabled) => set({ shopEnabled: enabled }),
      setTicketsEnabled: (enabled) => set({ ticketsEnabled: enabled }),
      setMapEnabled: (enabled) => set({ mapEnabled: enabled }),
    }),
    {
      name: 'driveitnq-settings',
    }
  )
);
